import {Button, Col, Form, InputGroup} from "react-bootstrap";
import dashboard from "../../../../assets/img/dashboard.webp";
import React, {useState} from "react";
import "./WithSubscribe.css"
import {useTranslation} from "react-i18next";
import {useDispatch} from 'react-redux';
import {useNavigate} from "react-router-dom";
import baseHostname from "../../../../hostname";
import {Captcha} from "../../common/Captcha";
import {routes} from "../../../../routes";
import {TermsAndConditions} from "../../../TermsAndConditions";
import {I18nService} from "../../../../service/i18nService";


const WithAnalyze = () => {
    const {t, i18n} = useTranslation();

    const [validated, setValidated] = useState(null);
    const [formState, setFormState] = useState('initial');
    const [isChecked, setIsChecked] = useState(false);
    const [captchaVerified, setCaptchaVerified] = useState(false);

    const isVerified = isChecked && captchaVerified;

    const dispatch = useDispatch();
    const navigate = useNavigate(); // Hook for programmatic navigation
    const i18nService = new I18nService();
    const currentLang = i18nService.getLanguage();

    function onFormSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        const formData = new FormData(event.target);
        const domain = formData.get("domain");
        const selector = formData.get("selector");

        function getHostname(url) {
            try {
                // If the URL doesn't start with http:// or https://, prepend 'http://'
                if (!/^https?:\/\//i.test(url)) {
                    url = 'http://' + url;
                }
                return new URL(url).hostname;
            } catch (e) {
                console.error(e);
                return ''; // Invalid URL
            }
        }

        const hostname = getHostname(domain.trim());

        if (hostname === '') {
            setValidated(false);
            alert('Please enter your domain');
            return;
        }

        if (!isChecked) {
            setValidated(false);
            alert('You must agree to the terms before proceeding.');
            return;
        }

        setValidated(true);
        setFormState('loading');

        fetch(
            baseHostname + '/index.php/domain/analyze/' + hostname + (selector === "" ? "" : ("/" + selector)),
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then(response => {
                if (!response.ok) {
                    console.warn('Server returned an error:', response.status);
                    setFormState('error');
                    return null;
                }
                return response.json();
            })
            .then(data => {
                if (data) {
                    // Save the DMARC validation result into Redux
                    dispatch({type: 'SET_VALIDATION_RESULT', payload: data});
                    setFormState('success');
                    resetForm();
                    // Redirect to the results page
                    navigate("/" + currentLang + "/" + routes["analyzeResults"][currentLang]);
                }
            })
            .catch(error => {
                console.error('Error during API call:', error);
                setFormState('error');
                resetForm();
            });
    }

    function resetForm() {
        setTimeout(
            () => {
                setFormState('initial')
            },
            5000
        )
    }


    return (
        <section
            className="row align-items-center text-center text-lg-start ps-4 pe-4 pt-5 pb-5 g-5"
            aria-labelledby="analyze-heading"
        >
            <Col xs={12} lg={6} className="px-lg-5">
                <h1
                    id="analyze-heading"
                    className="display-4 fw-bold text-uppercase"
                    dangerouslySetInnerHTML={{__html: t("pages.home.hero.withAnalyze.title")}}>
                </h1>
                <p className="mt-3">
                    {t("pages.home.hero.withAnalyze.subTitle")}
                </p>
                <Form
                    className="p-4 rounded bg-white mt-4"
                    validated={validated}
                    onSubmit={onFormSubmit}
                >
                    <div className="mb-3 text-center text-md-start">
                        <h4 className="fw-bold text-dark mb-1">
                            {t("pages.home.hero.withAnalyze.ctaInfo")}
                        </h4>
                        <p className="text-muted small mb-0">
                            {t("pages.home.hero.withAnalyze.subTitle")}
                        </p>
                    </div>

                    <InputGroup className="mb-3">
                        <InputGroup.Text>
                            <i className="bi bi-globe2"></i>
                        </InputGroup.Text>
                        <Form.Control
                            type="text"
                            name="domain"
                            placeholder={t("pages.home.hero.withAnalyze.form.domain.placeholder")}
                            aria-label="Domain"
                            disabled={!isVerified}
                            required
                        />
                    </InputGroup>

                    <InputGroup className="mb-3">
                        <InputGroup.Text>
                            <i className="bi bi-funnel"></i>
                        </InputGroup.Text>
                        <Form.Control
                            type="text"
                            name="selector"
                            placeholder={t("pages.home.hero.withAnalyze.form.selector.placeholder")}
                            aria-label="Selector"
                            disabled={!isVerified}
                        />
                    </InputGroup>

                    <Form.Group controlId="formBasicCheckbox" className="mb-3">
                        <TermsAndConditions checked={isChecked}
                                            onChange={(e) => setIsChecked(e.target.checked)}></TermsAndConditions>
                    </Form.Group>

                    <div className="mb-3">
                        <Captcha onSolutionVerified={() => {
                            setCaptchaVerified(true)
                        }}
                                 onSolutionRejected={() => {
                                     setCaptchaVerified(false)
                                 }}
                        ></Captcha>
                    </div>

                    <div className="d-grid">
                        <Button
                            type="submit"
                            className="btn btn-primary text-white fw-bold py-2"
                            disabled={!isChecked}
                        >
                            {t("pages.home.hero.withAnalyze.form.button.text")}
                        </Button>
                    </div>
                </Form>
            </Col>
            <Col xs={12} lg={6} className="text-center mt-5 mt-lg-0">
                <img
                    src={dashboard}
                    alt={t("pages.home.hero.withAnalyze.dashboardImage.alt")}
                    className="img-fluid rounded shadow w-100"
                    loading={"lazy"}
                />
            </Col>
        </section>
    );
};

export default WithAnalyze;
